import { useEffect } from "react"

import { UseFormReturn } from "react-hook-form"

import {
	buildDefaultCancelTypeSettingInputs,
	buildDefaultCancelTypeSettingInputsForUenoClinic,
	buildDefaultCancelTypeSettingInputsForZeroFive,
	buildDefaultCancelTypeSettingInputsForZeroThree,
} from "./defaults"

import {
	companySmsSendingRuleModalMode,
	CompanySmsSendingRuleModalMode,
} from "@/souhl_admin/components/features/companies/sms-sending-rule/const"
import type { CancelPolicyTemplateType } from "@/souhl_admin/gql/__generated__/graphql"
import { CompanySmsSendingRuleV2EditType } from "@/souhl_admin/utils/form/companySmsSendingRuleV2Edit"

export const useZeroThreeShortcut = (
	methods: UseFormReturn<CompanySmsSendingRuleV2EditType>,
	mode: CompanySmsSendingRuleModalMode
) => {
	const isCreateMode =
		mode === companySmsSendingRuleModalMode.CREATE ||
		mode === companySmsSendingRuleModalMode.DUPLICATE_AND_CREATE
	useEffect(() => {
		if (!isCreateMode) return

		// setValue("cancelTypeSettingInputs", ...) だと行内の useFieldArray (encouragingRereservationUnits / manuallyClaimingUnits) に
		// 変更が通知されず表示が古いまま残るため、reset で全 field array を作り直す
		const applyTemplate = (
			cancelPolicyTemplateType: CancelPolicyTemplateType,
			cancelTypeSettingInputs: CompanySmsSendingRuleV2EditType["cancelTypeSettingInputs"]
		) => {
			methods.reset(
				{
					...methods.getValues(),
					cancelPolicyTemplateType,
					cancelTypeSettingInputs,
				},
				{ keepDefaultValues: true }
			)
		}

		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.ctrlKey && e.shiftKey && e.key === "T") {
				e.preventDefault()
				const current = methods.getValues("cancelPolicyTemplateType")
				const next: CancelPolicyTemplateType =
					current === "ZERO_THREE" ? "ZERO_ONE" : "ZERO_THREE"
				let cancelTypeSettingInputs: CompanySmsSendingRuleV2EditType["cancelTypeSettingInputs"]
				if (next === "ZERO_THREE") {
					cancelTypeSettingInputs =
						buildDefaultCancelTypeSettingInputsForZeroThree()
				} else {
					cancelTypeSettingInputs = buildDefaultCancelTypeSettingInputs()
				}
				applyTemplate(next, cancelTypeSettingInputs)
			}

			if (e.ctrlKey && e.shiftKey && e.key === "U") {
				e.preventDefault()
				applyTemplate(
					"UENO_CLINIC",
					buildDefaultCancelTypeSettingInputsForUenoClinic()
				)
			}

			if (e.ctrlKey && e.shiftKey && e.key === "F") {
				e.preventDefault()
				applyTemplate(
					"ZERO_FIVE",
					buildDefaultCancelTypeSettingInputsForZeroFive()
				)
			}
		}

		document.addEventListener("keydown", handleKeyDown)
		return () => document.removeEventListener("keydown", handleKeyDown)
	}, [isCreateMode, methods])

	return { isCreateMode }
}
